export default {
  mounted: (el: HTMLElement, binding: DirectiveBinding, vnode: VNode) => {
    // console.info("inserted");
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        // 変更を検知した要素
        // console.log(entry.target);

        // 検知した変更の矩形
        // const rect = entry.contentRect;
        // console.log(rect.top, rect.left);
        // console.log(rect.width, rect.height);
        if (binding.value) binding.value(entry.contentRect)
      }
    })
    resizeObserver.observe(el)
    el.addEventListener('removeResizeObserver', () => {
      //   console.info("disconnect");
      resizeObserver.disconnect()
    })
  },
  unmounted: (el: HTMLElement) => {
    el.dispatchEvent(new CustomEvent('removeResizeObserver'))
  },
}
